import api from '@/client/core/api'
import type { GetAllNodeContainersResponse } from '@/typings/api/instagram_instantwin_node_container'

export type PreviewScenarioData = GetAllNodeContainersResponse['data']

type GetAllInstagramScenarioContainersApiResponse = Partial<GetAllNodeContainersResponse> & {
  error?: {
    type?: string
    message?: string
    status?: number
  }
}

export class GetAllInstagramScenarioContainersApiError extends Error {
  constructor(
    public type: string,
    message?: string,
    public status?: number
  ) {
    super(message || type)
  }
}

export async function getAllInstagramScenarioContainers(prizeId: number): Promise<PreviewScenarioData> {
  const axiosResult = await api.get<GetAllInstagramScenarioContainersApiResponse>(
    '/instagram_instantwin_node_container/all',
    { params: { prizeId } }
  )

  if (axiosResult instanceof Error) {
    throw axiosResult
  }

  if (axiosResult?.error?.type) {
    throw new GetAllInstagramScenarioContainersApiError(
      axiosResult.error.type,
      axiosResult.error.message,
      axiosResult.error.status
    )
  }

  if (!axiosResult?.data) {
    throw new GetAllInstagramScenarioContainersApiError(
      'INVALID_RESPONSE',
      'シナリオプレビュー取得APIのレスポンス形式が不正です。'
    )
  }

  return axiosResult.data
}
